import { render } from "./Footprint.vue?vue&type=template&id=06c5329a"
import script from "./Footprint.vue?vue&type=script&lang=js"
export * from "./Footprint.vue?vue&type=script&lang=js"

import "./Footprint.vue?vue&type=style&index=0&id=06c5329a&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__